// src/Dashboard/pages/teacher/ListingAdherents/components/AdherentsCardsGrid.jsx

import React from "react";
import { FaChevronDown } from "react-icons/fa";
import AdherentTeacherCard from "./AdherentTeacherCard";

export default function AdherentsCardsGrid({
  adherents = [],
  total = 0,
  birthdaySet,
  isAdmin,
  isTeacher,
  hasMore,
  onLoadMore,
  onOpenDetails,
  onManageGroups,
}) {
  const canManage = isAdmin || isTeacher;

  return (
    <>
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
        {adherents.map((adherent) => (
          <AdherentTeacherCard
            key={adherent.id}
            adherent={adherent}
            isBirthday={birthdaySet?.has?.(adherent.id)}
            canManage={canManage}
            onOpenDetails={onOpenDetails}
            onManageGroups={onManageGroups}
          />
        ))}
      </div>

      {hasMore && (
        <div className="mt-6 flex justify-center">
          <button
            type="button"
            onClick={onLoadMore}
            className="inline-flex items-center gap-2 rounded-2xl bg-[#013E8E] px-5 py-3 text-sm font-bold text-white shadow transition hover:bg-indigo-800"
          >
            Afficher plus
            <span className="rounded-full bg-white/20 px-2 py-0.5 text-xs">
              {adherents.length}/{total}
            </span>
            <FaChevronDown />
          </button>
        </div>
      )}
    </>
  );
}